"use client";

import Error from "next/error";

/**
 * Root 404 for requests the locale proxy never matched (no locale context
 * available here, so this stays minimal and English-only).
 */
export default function NotFound() {
  return (
    <html lang="en">
      <body>
        <Error statusCode={404} />
      </body>
    </html>
  );
}
